<template>
    <div class="row mt-4">
        <div class="col">
            <b-tabs card justified align="center"
                active-nav-item-class="font-weight-bold text-uppercase text-success"
            >
                <order></order>
                <order-table :orders="processedOrders" title="Ready for collection" :active="true"></order-table>
                <order-table :orders="unprocessedOrders" title="Awaiting processing"></order-table>
                <order-table :orders="fulfilledOrders" title="Completed"></order-table>
            
            </b-tabs>
        </div>
    </div>
</template>

<script>
import OrderTable from './OrderTable'
import Order from './Order'
export default {
    name: 'Orders',
    components: {
        OrderTable,
        Order
    },
    data() {
        return {
            order: null,
        }
    },
    computed : {
        processedOrders() {
            return this.$store.getters.PROCESSED_ORDERS
        },
        unprocessedOrders() {
            return this.$store.getters.UNPROCESSED_ORDERS
        },
        fulfilledOrders() {
            return this.$store.getters.FULFILLED_ORDERS
        }
    },
}
</script>